import { ExclamationCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon';
import { Button, Modal, Space } from 'antd';
import React, { useCallback, useEffect } from 'react';
interface IModalConfirm {
  isOpen: boolean;
  handleOk: () => void;
  handleCancel: () => void;
}

function ModalConfirm({ isOpen, handleOk, handleCancel }: IModalConfirm) {
  return (
    <Modal
      centered
      visible={isOpen}
      onCancel={() => handleCancel()}
      footer={null}
      maskClosable={false}>
      <div className="p-18">
        <Space wrap>
          <ExclamationCircleOutlined style={{ fontSize: 25, color: '#FAAD13' }} />
          <span style={{ fontSize: 16 }}>Bạn có muốn xóa đánh giá này hay không?</span>
        </Space>
        <div className="flex justify-end mt-30">
          <Space align="baseline">
            <Button key="back" size="large" onClick={handleCancel}>
              Không
            </Button>
            <Button key="submit" size="large" type="primary" danger onClick={handleOk}>
              Có
            </Button>
          </Space>
        </div>
      </div>
    </Modal>
  );
}

export default React.memo(ModalConfirm);
